import { Component, Input, OnInit } from '@angular/core';
import { JWTUser } from 'Model';
import { UtilserviceService } from 'app/services/utilservice.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-verify-account-popup',
  templateUrl: './verify-account-popup.component.html',
  styleUrls: ['./verify-account-popup.component.scss', '../subjectcombination/subjectcombination.component.scss']
})
export class VerifyAccountPopupComponent implements OnInit {
  @Input() isPopupVisible: boolean;   
  verificationText: string;

  constructor(private util: UtilserviceService, private toastr: ToastrService) { }

  ngOnInit(): void {
  }
  resendVerification() {
    let user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
    this.util.resendVerification(user.email).then(
      () => {
        this.toastr.success("Successful")
        this.verificationText = "A confirmation email has been sent to you. Click the verification link to enable your Account. Ensure that you re-login with your credentials to have full access"
      }
    );
  }
}
